import React, {Component} from "react";

export default class downCaret extends Component{
    render() {
        const {color, width, height} = this.props;
        return (
            <svg width={width} height={height} viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.7677 1.375L9.25 9.51314L1.73231 1.375L16.7677 1.375Z" fill={color} stroke={color}/>
            </svg>
        )
    }
}
